import { gql } from '@apollo/client';

export const GET_SUBSCRIPTION_FEATURE_TOGGLES = gql`
  query getSubscriptionFeatureToggles {
    app {
      id
      autoRenewReminderPopupEnabled
      sandboxSubscriptionSkuCheatEnabled
      sandboxSubscriptionSkuCheatUserIds
      economicTransactionReceiptLogEnabled
      unblockFriendEnabled
    }
  }
`;

export const UPDATE_SUBSCRIPTION_FEATURE_TOGGLES = gql`
  mutation updateSubscriptionFeatureToggles(
    $autoRenewReminderPopupEnabled: Boolean
    $sandboxSubscriptionSkuCheatEnabled: Boolean
    $sandboxSubscriptionSkuCheatUserIds: [String!]
    $economicTransactionReceiptLogEnabled: Boolean
    $unblockFriendEnabled: Boolean
  ) {
    updateAppFeatureToggles(
      input: {
        autoRenewReminderPopupEnabled: $autoRenewReminderPopupEnabled
        sandboxSubscriptionSkuCheatEnabled: $sandboxSubscriptionSkuCheatEnabled
        sandboxSubscriptionSkuCheatUserIds: $sandboxSubscriptionSkuCheatUserIds
        economicTransactionReceiptLogEnabled: $economicTransactionReceiptLogEnabled
        unblockFriendEnabled: $unblockFriendEnabled
      }
    ) {
      autoRenewReminderPopupEnabled
      sandboxSubscriptionSkuCheatEnabled
      sandboxSubscriptionSkuCheatUserIds
      economicTransactionReceiptLogEnabled
      unblockFriendEnabled
    }
  }
`;
